"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M17.628 5.217H20.6a10.998 10.998 0 0 0-5.174-3.626c.884.898 1.636 2.138 2.203 3.626Zm.355 1.044c.469 1.554.75 3.322.794 5.217h4.167a10.886 10.886 0 0 0-1.614-5.217h-3.347Zm.794 6.26c-.044 1.896-.325 3.664-.794 5.218h3.347a10.885 10.885 0 0 0 1.614-5.217h-4.167Zm-1.149 6.262c-.567 1.487-1.32 2.728-2.203 3.625a10.998 10.998 0 0 0 5.174-3.625h-2.97Zm-11.256 0H3.4a10.997 10.997 0 0 0 5.174 3.625c-.884-.897-1.636-2.138-2.203-3.625Zm-.355-1.044c-.469-1.554-.75-3.322-.794-5.217H1.056c.09 1.906.669 3.686 1.614 5.217h3.347Zm-.794-6.26c.044-1.896.325-3.664.794-5.218H2.67a10.885 10.885 0 0 0-1.614 5.217h4.167Zm1.149-6.262c.567-1.488 1.32-2.728 2.203-3.626a10.998 10.998 0 0 0-5.174 3.626h2.97ZM1.984 18.603a.521.521 0 0 1-.078-.12A11.93 11.93 0 0 1 0 12c0-2.386.7-4.612 1.906-6.483a.522.522 0 0 1 .078-.12C4.134 2.147 7.821 0 12 0c4.181 0 7.87 2.15 10.02 5.402.027.033.05.07.07.109A11.93 11.93 0 0 1 24 12a11.93 11.93 0 0 1-1.91 6.488.521.521 0 0 1-.072.112C19.868 21.851 16.18 24 12 24c-4.18 0-7.866-2.148-10.016-5.397ZM12.522 1.091v4.126h3.947c-.957-2.276-2.372-3.84-3.947-4.126Zm4.337 5.17h-4.337v5.217h5.21c-.049-1.892-.364-3.677-.873-5.217Zm.873 6.26h-5.21v5.218h4.337c.51-1.54.824-3.325.873-5.217Zm-1.263 6.262h-3.947v4.126c1.575-.286 2.99-1.85 3.947-4.126Zm-4.99 4.126v-4.126H7.53c.957 2.276 2.372 3.84 3.947 4.126ZM7.14 17.74h4.337v-5.217h-5.21c.049 1.892.364 3.677.873 5.217Zm-.873-6.26h5.21V6.26H7.141c-.51 1.54-.824 3.325-.873 5.217ZM7.53 5.216h3.947V1.091c-1.575.286-2.99 1.85-3.947 4.126Z",
    clipRule: "evenodd"
  })]
});